import { defaultFetch } from "./baseApi";

export type UserType = {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
};

export const getUsersByProjectId = async (projectId: string) => {
    return defaultFetch<UserType[]>(`/v0/projects/${projectId}/users`);
}